import http from '@/utils/http/index';

// 发送邮件
/**
 *
 * @param { uName } params
 * @returns
 */
export function sendMail(params) {
  return http.get('/loginForgetPwd', { params });
}

// 验证邮箱验证码
/**
 *
 * @param { uName, fillCode } params
 * @returns
 */
export function codeVerify(params) {
  return http.get('/loginCodeVerify', { params });
}

// 修改密码
/**
 *
 * @param { operatorId, loginId, password } params
 * @returns
 */
export function updatePassword(data) {
  return http.post('/loginUpdatePwd', data);
}

// 获取登录图形验证码
export function getLoginCaptcha() {
  return http.get('/merLogin/captcha');
}

// 登录
/**
 *
 * @param { loginId, password, encrypt, captcha} params
 * @returns
 */
export function doLogin(data) {
  return http.post('/merLogin/doLogin', data);
}

// 退出登录
export function doLogout() {
  return http.get('/merLogin/logout');
}

// 获取菜单列表
/**
 *
 * @param {*} params
 * @returns
 */
export function getMenusList(params) {
  return http.get('/merLogin/listMenus', { params });
}

// 获取菜单的按钮权限
/**
 *
 * @param {*} params
 * @returns
 */
export function listMenuButtons(pageId) {
  return http.get(`/merLogin/listMenuButtons?parentId=${pageId}`);
}

// 获取菜单的按钮权限
/**
 *
 * @param {
 * oldPwd
 * newPwd
 * } params
 * @returns
 */
export function updatePwd(data) {
  return http.post('/updatePwd', data);
}

/**
 * 密码重置
 * @param {*} data
 * @returns
 */
export function resetPassword(data) {
  return http.post('/updateMerLoginPassword', data);
}

/**
 * 使用 token 登录
 * @param {*} data
 */
export function loginByToken(data) {
  return http.post('/merLogin/loginByToken', data);
}

/**
 * 重置密码--修改登录邮箱
 */
export function resetLoginPassword(data) {
  return http.post('/merLogin/updateEmailLogin', data);
}

/**
 * 注册
 */
export function registerMerchant(data) {
  return http.post('/merLogin/registerMerchant', data);
}

/**
 * 获取手机验证码
 * @param {*} data
 * @returns
 */
export function getPhoneCaptcha(data) {
  return http.post('/merLogin/getPhoneCaptcha', data);
}

/**
 * 获取邮箱验证码
 * @param {*} data
 * @returns
 */
export function sendEmailCaptcha(data) {
  return http.post('/merLogin/getEmailCaptcha', data);
}

/**
 * 完善信息
 * @param {*} data
 * @returns
 */
export function improveInformation(data) {
  return http.post('/merLogin/improveInformation', data);
}

// 临时保存完善信息
export function postCacheImproveInformation(data) {
  return http.post('/merLogin/cache/improveInformation', data);
}

// 获取临时保存完善信息
export function queryCacheImproveInformation() {
  return http.get('/merLogin/cache/improveInformation');
}

/**
 * 获取完善信息
 * @param {*} data
 * @returns
 */
export function getUserInformation() {
  return http.get('/merLogin/getUserInformation');
}

/**
 * 修改完善信息
 * @param {*} data
 * @returns
 */
export function updateInformation(data) {
  return http.post('/merLogin/updateInformation', data);
}

/**
 * Payout 新增完善信息（带手机号）
 * @param {*} data
 * @returns
 */
export function addMerchantInformation(data) {
  return http.post('/merLogin/addMerchantInformation', data);
}

/**
 * Payout 修改完善信息
 * @param {*} data
 * @returns
 */
export function updateMerchantInformation(data) {
  return http.post('/merLogin/updateMerchantInformation', data);
}

export function getMerchantList() {
  return http.get('/merOperator/listMerchant');
}

/**
 * 快速注册
 * @param {*} data
 * @returns
 */
export function quickRegistrationInfo(data) {
  return http.post('/merLogin/quickRegistration', data);
}

/**
 * 切换账号
 * @param {*} data
 * @returns
 */
export function switchAccount(data) {
  return http.post('/merLogin/switchAccount', data);
}

/**
 * 设置默认账户
 * @param {*} id
 * @returns
 */
export function setDefaultLoginAccount(id) {
  return http.post(`/merOperator/defaultLoginAccount/${id}`);
}

export function updateMerchantProfile(data) {
  return http.post('/merchant/profile/update', data);
}
// 获取用户审核信息
export function getMerchantAudit() {
  return http.get('/merchant/account/getMerchantAuditLastRecord?code=09');
}
